import Tree from "../../../../structure/tree";
import CommonRules from "../../../common/rules/common-rules";
import TennisRules from "../../../tennis/rules/list";
import Ruleset from "../../enums/ruleset";

//Rules are processed depth first
const DefaultTennisRules = {
    id: Ruleset.DefaultTennis.code,
    name: Ruleset.DefaultTennis.name,
    rules: new Tree(CommonRules.Root, [
        new Tree(TennisRules.General.FinalizedMatch.Single, [
            new Tree(TennisRules.General.Scoring.Single, [
                new Tree(TennisRules.General.Scoring.SingleScoring, [])
            ])
        ]),
        new Tree(TennisRules.General.FinalizedMatch.Double, [
            new Tree(TennisRules.General.Scoring.Double, [
                new Tree(TennisRules.General.Scoring.DoubleScoring, [])
            ])
        ]),
        new Tree(TennisRules.General.FinalizeEvent, [])
    ])
};

export default DefaultTennisRules;
